import { z } from 'zod';
import { emailSchema } from './email.js';
import { slugSchema } from './slug.js';
import { systemDisplayNameSchema } from './system-display-name.js';
export const registerSchema = z.object({
    email: emailSchema,
    password: z.string().min(12).max(128),
    // SCRUM-312: the new-organization display name (the "System Name"). Shared
    // schema trims + rejects empty/control-char so the SystemName VO + global
    // registry never receive an unnormalizable value (no unmapped 500).
    name: systemDisplayNameSchema(255).optional(),
    organizationSlug: slugSchema.optional(),
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1),
});
export const verifyEmailQuerySchema = z.object({
    token: z
        .string()
        .length(64)
        .regex(/^[0-9a-f]+$/, 'Token must be hex-encoded'),
});
/**
 * Body schema for the FE-facing `POST /auth/verify-email`. Same shape
 * as `verifyEmailQuerySchema` (still `{ token }`) — the FE migration
 * away from the legacy GET keeps the wire contract identical, only
 * the HTTP method (and the page that issues it) changes.
 */
export const verifyEmailBodySchema = verifyEmailQuerySchema;
/**
 * Schema for `POST /auth/forgot-password`.
 * Structural validation only — no domain policy enforced here.
 */
export const requestPasswordResetSchema = z.object({
    email: z.string().email(),
});
/**
 * Schema for `POST /auth/reset-password`.
 * Token must be exactly 64 lowercase hex characters (sha256 raw hex digest).
 * Password length 12..128 is structural only; common-password blacklist lives
 * in the domain `validatePassword` helper (applied in the use case, step 14).
 */
export const resetPasswordSchema = z.object({
    token: z.string().regex(/^[0-9a-f]{64}$/, 'Token must be 64 lowercase hex characters'),
    newPassword: z.string().min(12).max(128),
});
//# sourceMappingURL=auth.js.map